import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/cart";
import Layout from "@/components/Layout";
import Catering from "@/pages/Catering";
import CateringQuotation from "@/pages/CateringQuotation";
import { ScrollProgress, CursorSpotlight } from "@/components/Motion";
import Landing from "@/pages/Landing";
import Menu from "@/pages/Menu";
import Playground from "@/pages/Playground";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import CateringTracking from "./pages/CateringTracking";
import OrderTracking from "@/pages/OrderTracking";
import AdminPanel from "@/pages/AdminPanel";
import KitchenPanel from "@/pages/KitchenPanel";
import DeliveryPanel from "@/pages/DeliveryPanel";
import Founder from "@/pages/Founder";
import Feedback from "@/pages/Feedback";

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollProgress />
        <CursorSpotlight />
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/playground" element={<Playground />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/track" element={<OrderTracking />} />
            <Route path="/catering/tracking/:enquiryId" element={<CateringTracking />}/>
            <Route path="/catering" element={<Catering />} />
            <Route path="/catering/quotation/:enquiryId" element={<CateringQuotation />}/>
            <Route path="/track/:orderId" element={<OrderTracking />} />
            <Route path="/founder" element={<Founder />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/kitchen" element={<KitchenPanel />} />
            <Route path="/delivery" element={<DeliveryPanel />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
